import './QuestionEditor.css'
import { useSelector } from "react-redux";
import { selectCurrentLang, selectTranslations } from "../../services/i18n/i18nSlice";

import minimize_img from '../../assets/images/minimize.svg'

import link_img from '../../assets/images/questions/link.svg'
import paper_img from '../../assets/images/questions/paper.svg'
import trash_img from '../../assets/images/trash.svg'
import ai_img from '../../assets/images/questions/ai.svg'

import Form from 'react-bootstrap/Form';
import { useEffect, useRef, useState } from 'react';
import UploadButton from '../UploadButton';
import SecureImage from '../_partials/SecuredImage';
import { API_URL } from '../../config/constants';
import Tabs from 'react-bootstrap/Tabs';
import Tab  from 'react-bootstrap/Tab';

export default function QuestionEditor(props){

    const t = useSelector(selectTranslations)

    const [showLinkInput, setShowLinkInput] = useState(false)
    const [showPaperInput, setShowPaperInput] = useState(false)
    const [autoFocusIndex, setAutoFocusIndex] = useState(null)

    const handleAddBlock = () => {
        console.log('click');
        let _blocks = structuredClone(props.questionData.blocks || [])
        props.handleDataChange({
            ...props.questionData,
            blocks: [..._blocks,
                {
                    text: "",
                    answers: []
                }
            ]
        })
    }

    const handleUpdateData = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        props.handleDataChange({
            ...props.questionData,
            [name]: value
        })
    }

    const handleUpdatePillData = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        props.handleDataChange({
            ...props.questionData,
            pill:{
                ...props.questionData?.pill,
                [name]: value
            }
        })
    }

    const handleUploadPillImage = (e) => {
        props.handleDataChange({
            ...props.questionData,
            pill:{
                ...props.questionData?.pill,
                image_url: `${e}`
            }
        })
    }
    const handleRemovePillImage = (e) => {
        props.handleDataChange({
            ...props.questionData,
            pill:{
                ...props.questionData?.pill,
                image_url: null
            }
        })
    }

    const handleUpdateAnswerData = (e, index) => {
        const target = e.target;
        const name = target.name;
        const value = target.type === "checkbox" ? target.checked : target.value;
        
        let _answers = structuredClone(props.questionData.answers || []);
        
        if (index < _answers.length) {
            _answers[index] = {
                ..._answers[index],
                [name]: value
            };
        } else {
            _answers.push({
                [name]: value,
                is_correct_answer: false
            });
        }
        
        props.handleDataChange({
            ...props.questionData,
            answers: _answers
        });

        // Attiviamo l'autoFocus solo per il nuovo input appena creato
        setAutoFocusIndex(index >= _answers.length - 1 ? index : null);
    };

    const handleUpdateBlockAnswerData = (e,block_index, answer_index) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _blocks = structuredClone(props.questionData.blocks)
        let _answers = _blocks[block_index].answers || []
        if(answer_index < _answers?.length)
            _answers[answer_index] = {
                ..._answers[answer_index],
                [name]:value
            }
        else 
            _answers.push({
                [name]: value,
                is_correct_answer: false
            })
        _blocks[block_index] = {
            ..._blocks[block_index],
            answers: _answers
        }
        props.handleDataChange({
            ...props.questionData,
            blocks: _blocks
        })
        
        // Imposta il focus sull'ultima risposta aggiunta nel blocco attuale
        setAutoFocusIndex({ blockIndex: block_index, answerIndex: answer_index });
    }

    const handleUpdateBlockData = (e,index) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _blocks = structuredClone(props.questionData.blocks)
        _blocks[index] = {
            ..._blocks[index],
            [name]:value
        }
        props.handleDataChange({
            ...props.questionData,
            blocks: _blocks
        })
    }

    const handleRemoveAnswer = (index) => {
        let _answers = structuredClone(props.questionData.answers)
        if (index > -1) { 
            _answers.splice(index, 1); 
        }
        props.handleDataChange({
            ...props.questionData,
            answers: _answers
        })
    }

    const handleRemoveBlockAnswer = (block_index, answer_index) => {
        let _blocks = structuredClone(props.questionData.blocks)
        let _answers = _blocks[block_index].answers
        if (answer_index > -1) { 
            _answers.splice(answer_index, 1); 
        }
        _blocks[block_index] = {
            ..._blocks[block_index],
            answers: _answers
        }
        props.handleDataChange({
            ...props.questionData,
            blocks: _blocks
        })
    }

    const handleUploadImage = (e) => {
        props.handleDataChange({
            ...props.questionData,
            image_url: `${e}`
        })
    }
    const handleRemoveImage = (e) => {
        props.handleDataChange({
            ...props.questionData,
            image_url: null
        })
    }

    const handleUploadBlockImage = (e,index) => {
        let _blocks = structuredClone(props.questionData.blocks)
        _blocks[index] = {
            ..._blocks[index],
            image_url: `${e}`
        }
        props.handleDataChange({
            ...props.questionData,
            blocks: _blocks
        })
    }
    const handleRemoveBlockImage = (index) => {
        let _blocks = structuredClone(props.questionData.blocks)
        _blocks[index] = {
            ..._blocks[index],
            image_url:null
        }
        props.handleDataChange({
            ...props.questionData,
            blocks: _blocks
        })
    }

    const closeQuestion = () => {
        props.updateQuestions(props.closeQuestion)
    }

    return(
        <>
            { props.show?
                <div id='question_editor'>
                    <div className='d-flex justify-content-between'>
                        <h3>{props?.is_new ? t.question.new_question : t.question.edit_question}</h3> 
                        <div className='d-flex'>
                            {
                                props.questionData?.ai_generated &&
                                    <img src={ai_img} className='me-3' style={{maxWidth:"35px"}} title={t.ai_assistant.ai_generated}/>
                            }
                            <img src={minimize_img} onClick={()=>props.closeQuestion()} className="pointer" />
                        </div>
                    </div>
                    <div className='inner-container'>
                    <Tabs
                        defaultActiveKey="question"
                        id="question-blocks"
                        className="mb-3 rounded_tabs"
                    >
                        <Tab eventKey={`question`} title={`${t.question.question}`} >
                    <div className='row'>
                        <div className='col-9'>
                            <Form.Group controlId="question_text" className='ms-2'>
                                <Form.Label>{t.question.question_text}</Form.Label>
                                <Form.Control className='minw-0' type="text" as={'textarea'} value={props.questionData?.text || ''} name="text" onChange={handleUpdateData} />
                                { props.questionData?.question_type === "fill" ?
                                    <Form.Text className='text-muted'>{t.question.fill_hint}</Form.Text>
                                : null}
                            </Form.Group>
                        </div>
                        <div className='col-3'>
                            <Form.Group controlId="question_type" >
                                <Form.Label>{t.question.question_type}</Form.Label>
                                <Form.Select className='minw-0' value={props.questionData?.question_type || ''} name="question_type" onChange={handleUpdateData} >
                                    <option value="base">{t.question.single_choice}</option>
                                    <option value="multi">{t.question.multiple_choice}</option>
                                    <option value="block">{t.question.block_question}</option>
                                    <option value="survey">{t.question.survey_question}</option>
                                    <option value="fill">{t.question.fill_question}</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-12'>
                            <Form.Group controlId="question_media" className='ms-2'>
                                <Form.Label>{t.question.add_media}</Form.Label>
                            </Form.Group>
                            <div className='d-flex mb-3'>
                                { !props.questionData?.link && !showLinkInput ?
                                <button className='me-2 secondary' onClick={()=>setShowLinkInput(true)}>
                                    <img src={link_img} alt='' />
                                    {t.question.link}
                                </button> : "" }
                                { !props.questionData?.image_url ?
                                    <UploadButton className='me-2 secondary' accept='image/png, image/jpeg, image/jpg' label={t.question.file} type='questions' onUpload={handleUploadImage}/>
                                : null}
                                { !props.questionData?.paper && !showPaperInput ?
                                <button className='secondary' onClick={()=>setShowPaperInput(true)}>
                                    <img src={paper_img} alt='' />
                                    {t.question.paper}
                                </button> : "" }
                            </div>
                            
                            
                        </div>
                        <div className='row'>
                            {
                                props.questionData?.image_url ?
                                <div className='col-6'>
                                    <Form.Group controlId="question_media" className='mt-2'>
                                        <Form.Label>{t.question.file}</Form.Label>
                                        <div className='question_image'>
                                            <div style={{maxWidth:'100px'}}>
                                            <SecureImage className="w-100" imageUrl={`${API_URL}${props.questionData?.image_url}`} />
                                            </div>
                                            <img src={trash_img} className='pointer' onClick={handleRemoveImage} />
                                        </div>
                                        
                                    </Form.Group>
                                </div> : ""
                            }
                            {
                                props.questionData?.link || showLinkInput ?
                                <div className='col-6'>
                                    <Form.Group controlId="question_media" className='mt-2'>
                                        <Form.Label>{t.question.link}</Form.Label>
                                        <Form.Control placeholder='https://www......'  type="text" value={props.questionData?.link || ''} name="link" onChange={handleUpdateData} />
                                    </Form.Group> 
                                </div> : ""
                            }
                        </div>
                            
                            {
                                props.questionData?.paper || showPaperInput ?
                                <Form.Group controlId="question_media" className='mt-2'>
                                    <Form.Label>{t.question.paper}</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        placeholder={t.question.paper}
                                        style={{ height: '100px' }}
                                        value={props.questionData?.paper}
                                        name="paper" onChange={handleUpdateData}
                                    />
                                </Form.Group> : ""
                            }
                            
                    </div>
                    <hr />
                    <div className='row mt-3'>
                        {
                            props?.questionData?.question_type !== "block" ?
                            <>
                                <Form.Label>{t.question.answers}</Form.Label>
                                {
                                    props.questionData?.answers?.map((answer, a_i)=>{
                                        return(
                                            <Answer
                                                key={a_i}
                                                answer={answer}
                                                answer_index={a_i}
                                                handleUpdateData={(e)=>handleUpdateAnswerData(e,a_i)}
                                                removeAnswer={()=>handleRemoveAnswer(a_i)}
                                                autoFocus={autoFocusIndex === a_i}
                                            />
                                        )
                                    })
                                }
                                <Answer
                                    answer={null}
                                    answer_index={props.questionData?.answers?.length}
                                    handleUpdateData={(e)=>handleUpdateAnswerData(e,props.questionData?.answers?.length)}
                                />
                            </> :
                            <>
                                <div className='d-flex justify-content-between'>
                                    <Form.Label>{t.question.blocks}</Form.Label>
                                    <button onClick={handleAddBlock}>{t.question.add_block}</button>
                                </div>
                                
                                <Tabs
                                    defaultActiveKey="block_0"
                                    id="question-blocks"
                                    className="mb-3 rounded_tabs"
                                    >
                                
                                {
                                    props.questionData?.blocks?.map((block, b_i)=>{
                                        return(
                                            <Tab eventKey={`block_${b_i}`} title={`${t.question.block} ${b_i+1}`} key={b_i}>
                                                <Form.Group controlId="text" >
                                                    <Form.Label>{t.question.block_text}</Form.Label>
                                                    <Form.Control className='minw-0' type="text" value={block?.text || ''} name="text" onChange={(e)=>handleUpdateBlockData(e,b_i)} />
                                                </Form.Group>
                                                { !block?.image_url ?
                                                    <UploadButton className='mt-2 secondary' label={t.question.file} type='questions' accept='image/png, image/jpeg, image/jpg' onUpload={(e)=>handleUploadBlockImage(e,b_i)}/>
                                                : null}
                                                {
                                                    block?.image_url ?
                                                    <div className='col-6'>
                                                        <Form.Group controlId="question_media" className='mt-2'>
                                                            <Form.Label>{t.question.file}</Form.Label>
                                                            <div className='question_image'>
                                                                <div style={{maxWidth:'100px'}}>
                                                                <SecureImage className="w-100" imageUrl={`${API_URL}${block?.image_url}`} />
                                                                </div>
                                                                <img src={trash_img} className='pointer' onClick={()=>handleRemoveBlockImage(b_i)} />
                                                            </div>
                                                            
                                                        </Form.Group>
                                                    </div> : ""
                                                }
                                                <Form.Label className='mt-2'>{t.question.answers}</Form.Label>
                                                { block?.answers?.map((answer, a_i)=>{
                                                    return(
                                                        <Answer
                                                            key={a_i}
                                                            answer={answer}
                                                            answer_index={a_i}
                                                            handleUpdateData={(e)=>handleUpdateBlockAnswerData(e,b_i,a_i)}
                                                            removeAnswer={()=>handleRemoveBlockAnswer(b_i,a_i)}
                                                            autoFocus={autoFocusIndex?.blockIndex === b_i && autoFocusIndex?.answerIndex === a_i}                                                        />
                                                    )
                                                }) }
                                                <Answer
                                                    answer={null}
                                                    answer_index={block?.answers?.length}
                                                    handleUpdateData={(e)=>handleUpdateBlockAnswerData(e,b_i,block?.answers?.length)}
                                                />
                                            </Tab>
                                        )
                                    })
                                }
                                
                                </Tabs>
                            </>
                        }
                    </div>
                    </Tab>
                    <Tab eventKey={`pill`} title={`${t.question.pill}`} >
                        <Form.Group controlId="question_text" className='ms-2'>
                            <Form.Label>{t.question.pill_text}</Form.Label>
                            <Form.Control as="textarea" className='minw-0' type="text" value={props.questionData?.pill?.text || ''} name="text" onChange={handleUpdatePillData} />
                        </Form.Group>
                        { !props.questionData?.pill?.image_url ?
                            <UploadButton className='me-2 mt-3 secondary' accept='image/png, image/jpeg, image/jpg' label={t.question.pill_image} type='questions' onUpload={handleUploadPillImage}/>
                        : null}
                        {
                            props.questionData?.pill?.image_url ?
                            <div className='col-6'>
                                <Form.Group controlId="question_media" className='mt-2'>
                                    <Form.Label>{t.question.pill_image}</Form.Label>
                                    <div className='question_image'>
                                        <div style={{maxWidth:'100px'}}>
                                        <SecureImage className="w-100" imageUrl={`${API_URL}${props.questionData?.pill?.image_url}`} />
                                        </div>
                                        <img src={trash_img} className='pointer' onClick={handleRemovePillImage} />
                                    </div>
                                    
                                </Form.Group>
                            </div> : ""
                        }
                    </Tab>
                </Tabs>
                </div>
                <div className='d-flex mt-3 align-items-center bottom-controller'> 
                    <div className='col-6'>
                        <span className='text-danger pointer' onClick={props.removeQuestion}>{t.question.remove_question}</span>
                    </div>
                    <div className='col-6 d-flex'>
                        <button  className="secondary me-2" onClick={props.addQuestion}>
                            {t.question.new_question} +
                        </button>
                        <button onClick={closeQuestion}>
                            {t.buttons.save_and_exit}
                        </button>
                    </div>
                </div>
                </div>
            : null}
        </>
    )
}

const Answer = ({ answer, answer_index, handleUpdateData, removeAnswer, autoFocus }) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (autoFocus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [autoFocus]);

    return (
        <div className='answer_container'>
            <div className='answer_inner'>
                <input type='checkbox' className='input-check' name='is_correct_answer' checked={answer?.is_correct_answer} onChange={handleUpdateData}/>
                <Form.Control
                    ref={inputRef}
                    type="text"
                    value={answer?.text || ''}
                    name="text"
                    onChange={handleUpdateData}
                /> 
            </div>

            { answer ? <img src={trash_img} className='pointer' onClick={removeAnswer} /> : null }
        </div>
    );
}